import * as React from 'react';
import CloseMenu from 'src/images/close-menu.svg';
import CloseMenuHover from 'src/images/close-menu-hover.svg';
import Hamburger from 'src/images/hamburger.svg';
import RightArrow from 'src/images/right-arrow.svg';

import css from './hamburger-menu.css';


export const CollapseHamburgerMenu = () => {
  return (
    <div className={css.menuWrapper}>
      <div className={css.closeMenu}>
        <CloseMenu />
      </div>
      <div className={css.closeMenuHover}>
        <CloseMenuHover />
      </div>
    </div>
  );
};

export const ExpandHamburgerMenu = () => {
  return (
    <div className={css.menuWrapper}>
      <div className={css.closeMenu}>
        <Hamburger />
      </div>
      <div className={css.closeMenuHover}>
        <RightArrow />
      </div>
    </div>
  );
};
